import { PagePending } from "@/components/ui/PagePending";
import { onboardingStateQuery } from "@/api/supplier";
import { QueryHandler } from "@givenwell/components";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { DashboardPage } from "./DashboardPage";
import { GettingStartedPage } from "./GettingStartedPage";

export const Route = createFileRoute("/supplier/$supplierId/")({
  pendingComponent: PagePending,
  component: SupplierHome,
});

function SupplierHome() {
  const { supplierId } = Route.useParams();

  const onboardingState = useQuery(onboardingStateQuery(supplierId));

  return (
    <QueryHandler
      query={onboardingState}
      success={({ data: state }) => (state.is_complete ? <DashboardPage /> : <GettingStartedPage />)}
    />
  );
}
